import * as types from './mutation-types'

export default {  
  [types.GET_DATA_CEPS](state, payload = { cepData }) {
    state.cepData = payload.cepData
  },
  
}
